module.exports = __webpack_public_path__ + "static/010_Ginbar-0239e7d0f046a7f3f9211d8de0b920f2.jpg";